/** Shared with Avail History admin timeline and planner cards — keep in sync. */

export const TIMELINE_COLOR_GREEN_SOLID = '#1FC16B';
export const TIMELINE_COLOR_GRAY_SOLID = '#D9DEE7';
export const TIMELINE_COLOR_GREEN_RING = '#1FC16B';
export const TIMELINE_COLOR_GRAY_RING = '#8B93A6';
export const TIMELINE_COLOR_BORDER_GREEN_FILL = '#E8FAF0';
export const TIMELINE_COLOR_BORDER_GRAY_FILL = '#F0F2F5';
export const TIMELINE_COLOR_NOW_FILL = '#FFFFFF';
export const TIMELINE_COLOR_NOW_RING = '#000000';
export const TIMELINE_NOW_DOT_BORDER = '#131517';

export function normalizeTimelineApiColorKey(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  const m = s.match(/^#?([0-9a-f]{6})$/i);
  if (!m) return null;
  return `#${m[1].toLowerCase()}`;
}

/**
 * @param {string|null|undefined} apiColor
 * @returns {{ background: string, border: string }|null}
 */
export function getTimelineCirclePaintFromApiColor(apiColor) {
  const key = normalizeTimelineApiColorKey(apiColor);
  switch (key) {
    case '#00ffff':
      return {
        background: TIMELINE_COLOR_BORDER_GREEN_FILL,
        border: `2px solid ${TIMELINE_COLOR_GREEN_RING}`,
      };
    case '#aaffff':
      return {
        background: TIMELINE_COLOR_BORDER_GRAY_FILL,
        border: `2px solid ${TIMELINE_COLOR_GRAY_RING}`,
      };
    case '#00ff33':
      return {
        background: TIMELINE_COLOR_GREEN_SOLID,
        border: '2px solid transparent',
      };
    case '#aaffaa':
      return {
        background: TIMELINE_COLOR_GRAY_SOLID,
        border: '2px solid transparent',
      };
    case '#000000':
      return {
        background: TIMELINE_COLOR_NOW_FILL,
        border: `2px solid ${TIMELINE_COLOR_NOW_RING}`,
      };
    default:
      return null;
  }
}
